import React, { useEffect } from 'react';

import { SkipLink } from '@root/components/shared/skip_link';

import { Action, useClientDataContext } from '@shared/client_data_context';

import { HomeBrandsSection } from './home/brands_section';
import { HomeComparisonSection } from './home/comparison_section';
import { HomeFaqSection } from './home/faq_section';
import { HomeHeader } from './home/header';
import { HomeHero } from './home/hero';
import { initLenisScroll } from './home/lenis_scroll';
import { HomeSecuritySection } from './home/security_section';
import { HomeSiteFooter } from './home/site_footer';
import { HomeStorageSection } from './home/storage_section';
import { HomeGlobalStyles, PageShell } from './home/styles';
import { HomeTestimonialsSection } from './home/testimonials_section';

const MAIN_CONTENT_ID = 'main-content';

const Home: React.FC = () => {
  const { dispatch } = useClientDataContext();

  useEffect(() => {
    dispatch({ type: Action.SetZip, payload: { zip: '' } });
  }, [dispatch]);

  useEffect(() => initLenisScroll(), []);

  return (
    <PageShell className="home-root">
      <HomeGlobalStyles />
      <SkipLink mainContentId={MAIN_CONTENT_ID} />
      <HomeHeader />
      <main id={MAIN_CONTENT_ID} style={{ flex: 1 }}>
        <HomeHero />
        <HomeStorageSection />
        <HomeSecuritySection />
        <HomeComparisonSection />
        <HomeTestimonialsSection />
        <HomeBrandsSection />
        <HomeFaqSection />
      </main>
      <HomeSiteFooter />
    </PageShell>
  );
};

export { Home };
